import React from 'react';
import ReactDOM from 'react-dom';

import './styles/_variables.scss';
import './styles/_globals.scss';
import './styles/_layout.scss';
import './styles/_typography.scss';

import * as serviceWorker from './serviceWorker';

import App from './App';
import Firebase, { FirebaseContext } from './firebase';

ReactDOM.render(
  <FirebaseContext.Provider value={new Firebase()}>
    <App />
  </FirebaseContext.Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();